import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { useNavigate } from "react-router-dom";
import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";
import { BootstrapAlert } from "../../components/BootstrapAlert";

// services
import { useCompleteTrainingMutation } from "../../store/services/moduleServerApi";

const Module_1_1_3 = () => {
  const navigate = useNavigate();
  const [
    completeTraining,
    {
      isLoading,
      error: { data: { message: errorMessage } = {} } = {},
      data: { message: successMessage } = {},
    },
  ] = useCompleteTrainingMutation();
  console.log(
    "isLoading, errorMessage, successMessage :>> ",
    isLoading,
    errorMessage,
    successMessage
  );

  const handleCompleteTraining = () => {
    completeTraining({ moduleNo: 3, end: 1 });
  };
  if (successMessage) {
    navigate("/overview");
  }

  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}
      <div className="col-sm-8">
        <div className="module-content">
          <section className="mb-5">
            <h1 className="blue text-uppercase b mt-5">
              3.0.21 Module Summary
            </h1>
            <p className="mt-3">Estimated time to complete: 1 minute</p>
          </section>
          <section className="mb-5 row">
            <div className="col-sm-12">
              <h2 className="b text-uppercase mb-3">
                <span className="orange">Congratulations!</span> You have
                completed Module 3: Case Studies, the final module in the
                required Core Amyvid Reader Training.
              </h2>
              <p>
                Please click the button below to mark your training complete.
                You will then be able to download your completion certificate or
                continue to the Additional Scans for Review section to further
                test your knowledge. 
              </p>
            </div>
          </section>
          <BootstrapAlert variant="danger" message={errorMessage} />
          <LdsButton
            classes="blue-button mt-3 mb-5"
            disabled={isLoading}
            onClick={handleCompleteTraining}
          >
            Mark Complete
          </LdsButton>
        </div>
      </div>
    </div>
  );
};

export default Module_1_1_3;
